<template>
  <div
    id="modal-notification-history"
    class="modal modal-right fade modal-more-filters"
    role="dialog"
  >
    <!-- <div> -->
    <div
      class="modal-dialog"
      role="document"
      style="width: 360px;"
    >
      <div
        class="modal-content"
        ref="section"
      >
        <div class="modal-header bg-dark">
          <h6 class="modal-title">
            {{ $t("_notification.Notification") }}
          </h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-body p-0 pb-5">
          <template v-if="!isloading">
            <template v-if="notification.length > 0">
              <div
                v-for="group in notification"
                :key="group.id"
              >
                <div class="bg-light border-bottom px-3 py-2">
                  <i class="fa-solid fa-calendar-days mr-2" />{{ convertTimezone(group.date) }}
                </div>
                <ul class="media-list">
                  <li
                    v-for="notice in group.noticeLists"
                    :key="notice.id"
                    class="media px-3 py-2 border-bottom mt-0"
                  >
                    <div class="mr-3 mt-1">
                      <span class="icon-notice"><i class="fa-solid fa-bell" /></span>
                    </div>
                    <div
                      v-if="notice.notification_type.name == 'inventory'"
                      class="media-body cursor-pointer"
                      @click="$parent.showModal()">
                      <div class="d-flex justify-content-between font-size-sm text-muted mb-1">
                        <span style="text-transform: capitalize;">{{ $t("_notification." + notice.notification_type.name) }}</span>
                        <span>{{ formatTime(notice.created_date) }}</span>
                      </div>
                      <div v-html="notificationIsLanguage(notice)" />
                    </div>
                    <div
                      v-else
                      class="media-body">
                      <div class="d-flex justify-content-between font-size-sm text-muted mb-1">
                        <span>{{ $t("_notification.Notice" + ' ' + notice.notification_type.name) }}</span>
                        <span>{{ formatTime(notice.created_date) }}</span>
                      </div>
                      <div v-html="notificationIsLanguage(notice)" />
                    </div>
                  </li>
                </ul>
              </div>
            </template>
            <template v-else>
              <div class="align-items-center d-flex h-100 justify-content-center">
                <div>
                  <div>
                    <img
                      src="@/assets/global_assets/images/notification/nodata_notification.png"
                      class="img-fluid"
                      alt=""
                      width="125px"
                    >
                  </div>
                  <div class="no-data pt-2 text-center">
                    {{ $t('Notification Not Found.') }}
                  </div>
                </div>
              </div>
            </template>
          </template>
          <template v-else>
            <div class="p-3">
              <placeholder-content is-load="true" />
            </div>
          </template>
        </div>
        <!-- $router.push({ name: 't.a.notification.index'}) -->
        <div class="modal-footer fixed-bottom bg-light border-top d-flex justify-content-between py-2 px-3">
          <button
            type="button"
            class="btn btn-light"
            @click="viewAllHistory"
          >
            {{ $t('_notification.View all notifications') }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            data-dismiss="modal"
          >
            {{ $t('Close') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import CentralApi from '@/services/endpoint/central.service'
import numeral from "numeral"
import Vuetable from "vuetable-2"
import Api from '@/services/endpoint/tenant.service';
import { convertTimezone } from "@/common/tenancy/convertTimezone";
import { humanDatetime } from "@/common/tenancy/datetime.js";
import PlaceholderContent from '@/plugins/PlaceholderContent.vue'
import Cookies from "js-cookie";

export default {
    name: 'ModalNotificationHistory',
    components: {
        // numeral,
        // Vuetable,
        PlaceholderContent
    },
    data() {
        return {
            notification: [],
            noticeLists: false,
            isloading: true
        }
    },
    async mounted() {
      await  this.getNotificationHistory();
      await  this.markNotificationRead();
        this.isloading = false;
    },
    methods: {
        viewAllHistory() {
            this.$parent.notificationHistoryModal = false;
            this.$router.push({ name: 't.a.notification.index' });
            $('#modal-notification-history').modal('hide');

        },
        async getNotificationHistory() {
            let data = await Api.Notification.getNotificationHistory();
            this.notification = data.data
            return true;

        },
        async markNotificationRead(){
            await Api.Notification.addNotificationRead().then((res) => {
              this.$parent.unRead = 0;
              this.$parent.user.unread = 0;

              delete this.$parent.user.login_date
              delete this.$parent.user.created_date
              delete this.$parent.user.updated_date

              Cookies.set('user', JSON.stringify(this.$parent.user), { domain: '.' + process.env.CENTRAL_API_ROOT });
            }).catch((err) => {
              console.log(err, 'err');
            });
            return true;
        },
        humanDatetime,
        convertTimezone(date) {
            return date != null && new Date(date) instanceof Date && !isNaN(new Date(date)) ? convertTimezone.utcToLocalDate(date) : '-';
        },
        formatTime: value => {
            const dateTime = convertTimezone.utcToLocal(value);
            return moment(dateTime).format("HH:mm");
        },
        notificationIsLanguage(Object) {
          let associate = null;
          let key = null;
          let massage = Object.massage;
          if(Object.notification_type.name == 'document') {
            // Document ============================================================================================================
            if(massage.indexOf('คำขอเปิดใช้งานกระเป๋าเงินได้รับการอนุมัติแล้ว') != -1) { // Approve
              associate = this.$t('The wallet activation request has been approved'); //EN คำขอเปิดใช้งานกระเป๋าเงินได้รับการอนุมัติแล้ว
            } else if(massage.indexOf('คำขอเปิดใช้งานเครดิตค่าขนส่งได้รับการอนุมัติแล้ว') != -1) { // Approve
              associate = this.$t('Your shipping credit activation request has been approved'); //EN คำขอเปิดใช้งานเครดิตค่าขนส่งได้รับการอนุมัติแล้ว
            } else if(massage.indexOf('คำขอเปิดใช้งาน COD (เก็บเงินปลายทาง)') != -1) { // Approve & Reject
              key = 'คำขอเปิดใช้งาน COD (เก็บเงินปลายทาง)';
              massage = massage.replace(massage.substring(massage.indexOf(key), key.length), '');
              associate = this.$t('COD activation request (Cash on delivery)'); //EN คำขอเปิดใช้งาน COD (เก็บเงินปลายทาง)
              if(massage.indexOf('ได้รับการอนุมัติแล้ว') != -1) { // Approve
                associate += massage.split("ได้รับการอนุมัติ")[0] + ' ' +this.$t('_notification.approved'); //EN ได้รับการอนุมัติแล้ว
              } else if(massage.indexOf('ถูกปฏิเสธ') != -1) { // Reject
                associate += massage.split("ถูก")[0] + ' ' +this.$t('_notification.reject'); //EN ถูกปฏิเสธ
              }
            } else if(massage.indexOf('คำขอเปิดใช้งานวอลเล็ตถูกปฏิเสธ') != -1) { // Reject
              associate = this.$t('Wallet activation request rejected'); //EN คำขอเปิดใช้งานวอลเล็ตถูกปฏิเสธ
            } else if(massage.indexOf('คำขอเปิดใช้งานเครดิตค่าขนส่งถูกปฏิเสธ') != -1) { // Reject
              associate = this.$t('Shipping credit activation request has been denied'); //EN คำขอเปิดใช้งานเครดิตค่าขนส่งถูกปฏิเสธ
            }
          } else if(Object.notification_type.name == 'cod') {
            // Cod =================================================================================================================
            if(massage.indexOf('ระบบได้โอนเงิน COD :') != -1) { // Approve
              key = 'ระบบได้โอนเงิน COD :';
              massage = massage.replace(massage.substring(massage.indexOf(key), key.length), '');
              associate = this.$t('The system has transferred COD money') + ':'; //EN ระบบได้โอนเงิน COD
              massage = massage.split("ประจำวันที่");
              associate += massage[0] + this.$t('of the day'); //EN ประจำวันที่
              massage = massage[1];
              massage = massage.split("ให้ท่านเป็นจำนวนเงิน");
              associate += massage[0] + this.$t('give you an amount'); //EN ให้ท่านเป็นจำนวนเงิน
              massage = massage[1];
              associate += massage.split("บาท")[0] + ' ' +this.$t('Baht') + ' ' +this.$t('already'); //EN บาท เรียบร้อยแล้ว
            }
          } else if(Object.notification_type.name == 'wallet') {
            // Wallet ==============================================================================================================
            if(massage.indexOf('คำขอเติมเงิน SMS:') != -1) { // Approve & Reject
              key = 'คำขอเติมเงิน SMS:';
              massage = massage.replace(massage.substring(massage.indexOf(key), key.length), '');
              associate = this.$t('SMS recharge request') + ':'; //EN คำขอเติมเงิน SMS
              massage = massage.split("จำนวน");
              associate += massage[0] + this.$t('qty'); //EN จำนวน
              massage = massage[1];
              massage = massage.split("ข้อความ");
              associate += massage[0] + this.$t('Message'); //EN ข้อความ
              massage = massage[1];
              if(massage.indexOf('ได้รับการยืนยันแล้ว') != -1) { // Approve
                associate += ' ' +this.$t('_notification.verified'); //EN ได้รับการยืนยันแล้ว
              } else if(massage.indexOf('ถูกปฏิเสธ') != -1) { // Reject
                key = 'ถูกปฏิเสธ';
                associate += ' ' +this.$t('_notification.reject'); //EN ถูกปฏิเสธ
                if(massage.indexOf('เนื่องจากชำระเงินไม่สำเร็จ') != -1) {
                  associate += ' ' +this.$t('due to unsuccessful payment'); //EN เนื่องจากชำระเงินไม่สำเร็จ
                } else {
                  associate += ' ' +massage.replace(massage.substring(massage.indexOf(key), key.length), ''); // Remark
                }
              }
            } else if(massage.indexOf('คำขอเติมเงินเครดิตค่าขนส่ง:') != -1) { // Approve & Reject
              key = 'คำขอเติมเงินเครดิตค่าขนส่ง:';
              massage = massage.replace(massage.substring(massage.indexOf(key), key.length), '');
              associate = this.$t('Shipping credit top-up request') + ':'; //EN คำขอเติมเงินเครดิตค่าขนส่ง
              massage = massage.split("จำนวน");
              associate += massage[0] + this.$t('qty'); //EN จำนวน
              massage = massage[1];
              massage = massage.split("บาท");
              associate += massage[0] + this.$t('Baht'); //EN บาท
              massage = massage[1];
              if(massage.indexOf('ได้รับการยืนยันแล้ว') != -1) { // Approve
                associate += ' ' +this.$t('_notification.verified'); //EN ได้รับการยืนยันแล้ว
              } else if(massage.indexOf('ถูกปฏิเสธ') != -1) { // Reject
                key = 'ถูกปฏิเสธ';
                associate += ' ' +this.$t('_notification.reject'); //EN ถูกปฏิเสธ
                if(massage.indexOf('เนื่องจากชำระเงินไม่สำเร็จ') != -1) {
                  associate += ' ' +this.$t('due to unsuccessful payment'); //EN เนื่องจากชำระเงินไม่สำเร็จ
                } else {
                  associate += ' ' +massage.replace(massage.substring(massage.indexOf(key), key.length), ''); // Remark
                }
              }
            }
          } else if(Object.notification_type.name == 'promotion') {
            // Promotion ===========================================================================================================
            if(massage.indexOf('ยอดเงินโปรโมชั่น:') != -1) { // Approve
              key = 'ยอดเงินโปรโมชั่น:';
              massage = massage.replace(massage.substring(massage.indexOf(key), key.length), '');
              associate = this.$t('Promotion amount') + ':'; //EN ยอดเงินโปรโมชั่น
              massage = massage.split("จำนวน");
              associate += massage[0] + this.$t('qty'); //EN จำนวน
              massage = massage[1];
              associate += massage.split("บาท")[0] + ' ' +this.$t('Baht') + ' ' +this.$t('_notification.verified'); //EN บาท ได้รับการยืนยันแล้ว
            }
          }else if(Object.notification_type.name == 'domain') {
            // Domain ===========================================================================================================
            if(massage.indexOf('การเปิดใช้งานโดเมน') != -1) {
              key = 'การเปิดใช้งานโดเมน';
              massage = massage.replace(massage.substring(massage.indexOf(key), key.length), '');
              associate = this.$t('_notification.Domain verification for') + ' ';
              if(massage.indexOf('ได้รับการอนุมัติการใช้งานแล้ว') != -1) { // Approve
                massage = massage.split("ได้รับการอนุมัติการใช้งานแล้ว");
                associate += massage[0] + this.$t('has been approved. Check it out!');
              } else if(massage.indexOf('ไม่ได้รับการอนุมัติ กรุณาตรวจสอบการตั้งค่าโดเมนของคุณ') != -1) { // Reject
                massage = massage.split("ไม่ได้รับการอนุมัติ กรุณาตรวจสอบการตั้งค่าโดเมนของคุณ");
                associate += massage[0] + this.$t('has been rejected. Please check your domain’s configuration.');
              }
            }
          }else if(Object.notification_type.name == 'inventory') {
            associate = this.$t(massage);
          }else {
            associate = massage;
          }
          return associate;
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/layouts/tenancy/admin/ModalNotificationHistory.vue